module.exports = __webpack_public_path__ + "static/media/placeholder_logos(2).513490fe.png";